export const POPUP_ANIMATION_DELAY = 750

export const wildcardToRegExp = (
  wildcardPattern: string,
  flags?: string,
): RegExp => {
  const regexMatch = /^\/(.+)\/([im]+)?$/.exec(wildcardPattern)
  if (regexMatch) {
    return new RegExp(regexMatch[1], regexMatch[2] || flags)
  }
  const pattern = wildcardPattern
    .replace(/[\-\[\]\/{}()?.\\^$|]/g, '\\$&')
    .replace(/\*/g, '.*?')
    .replace(/\+/g, '.+?')
  return new RegExp(`^${pattern}$`, flags)
}

export const gradientOpacity = (gradient: string, opacity: string): string => {
  try {
    const colors = gradient.match(/rgba\([^()]*\)|#\w+/g)

    colors?.forEach(color => {
      const [r, g, b, a] = color
        .split('(')[1]
        .split(')')[0]
        .split(',')
        .map(c => c.trim())

      const alpha = +a * +opacity

      gradient = gradient.replace(
        color,
        `rgba(${r}, ${g}, ${b}, ${Math.round(alpha * 100) / 100})`,
      )
    })

    return gradient
  } catch (e) {
    return gradient
  }
}
